import { BLANK_RULE } from '../helpers/rules';
import moment from 'moment';
import { keyBy } from 'lodash';
import {
    FETCH_RULE_KPIS,
    FETCH_RULES,
    RULES_DELETE,
    RULES_UPDATE,
    FETCH_RULE_LIST,
    SET_ACTIVE_RULE,
    SET_RULE_START_TIMESTAMP, 
    SET_RULE_END_TIMESTAMP,
    FETCH_RULE_TARGETS,
    SET_LEGACY_RULE_TABLE_PAGE_SIZE
} from '../actions/actionTypes';

const initialState = {
    activeRule:              {},
    kpis:                    {},
    items:                   {},
    ruleList:                [],
    ruleMeta:                {},
    ruleEndTimeStamp:        moment().local(),
    ruleStartTimeStamp:      moment().subtract(4, 'h').local(),
    ruleTargetsList:         [],
    ruleTargetsMeta:         {},
    legacyRuleTablePageSize: 20
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RULE_KPIS:
            return {
                ...state,
                kpis: {...action.payload}
            };
        case FETCH_RULES:
            return {
                ...state,
                items: keyBy((action.payload.data || []).map(rule => ({
                    // Ensures persisted data has appropriate default values
                    ...BLANK_RULE,
                    ...rule
                })), ({ id }) => id)
            };
        case RULES_DELETE: {
            const { [action.payload.id]: _, ...items } = state.items;
            return {
                ...state,
                items
            };
        }
        case RULES_UPDATE:
            return {
                ...state,
                items: {
                    ...state.items,
                    [action.payload.data.id]: {
                        // Ensures persisted data has appropriate default values
                        ...BLANK_RULE,
                        ...action.payload.data
                    }
                }
            };
        case FETCH_RULE_LIST:
            return {
                ...state,
                ruleList: [...action.payload.data],
                ruleMeta: {...action.payload.meta}
            };
        case FETCH_RULE_TARGETS:
            return {
                ...state,
                ruleTargetsList: [...action.payload.data],
                ruleTargetsMeta: {...action.payload.meta}
            };
        case SET_RULE_START_TIMESTAMP:
            return {
                ...state,
                ruleStartTimeStamp: action.payload
            };
        case SET_RULE_END_TIMESTAMP:
            return {
                ...state,
                ruleEndTimeStamp: action.payload
            };
        case SET_ACTIVE_RULE:
            return {
                ...state,
                activeRule: action.payload
            };
        case SET_LEGACY_RULE_TABLE_PAGE_SIZE:
            return {
                ...state,
                legacyRuleTablePageSize: action.payload
            };
        default:
            return state;
    }
};
